<template>
  <v-card class="rounded-xl d-flex mb-4" :color="bgColor" outlined>
    <div :style="{ backgroundColor: 'white' }" class="rounded-xl ma-3 pa-1">
      <div class="d-flex flex-column" style="position: relative" elevation="0">
        <qrcode-vue
          :key="share?.id || 'P'"
          style="background-size: cover"
          class="d-flex justify-center pa-2 ma-0 rounded"
          :value="getQrCodeLink()"
          size="180"
          level="H"
          :background="'#fff'"
          renderAs="svg"
        />
        <div
          style="
            position: absolute;
            top: 0px;
            left: 0px;
            height: 100%;
            width: 100%;
          "
          class="d-flex justify-center align-center"
        >
          <div class="white d-flex rounded" style="padding: 2px">
            <img
              :src="images.favicon"
              contain
              style="width: 22px; height: 22px"
            />
          </div>
        </div>
      </div>
      <span class="text-10 text-center d-block" style="margin-top: -3px">
        Verifique a autenticidade do ingresso
      </span>
    </div>

    <ticket-dots color="#fff" :size="20" :space-factor="1.3" vertical />

    <div
      class="flex-grow-1 ml-5 mr-4 py-4"
      :class="{ 'secondary-ticket': secondary }"
      style="position: relative"
    >
      <v-row class="h-full mx-0" no-gutters>
        <v-col cols="">
          <div class="d-flex flex-grow-1 flex-column h-full justify-center">
            <h4 class="mb-0 black--text text-truncate" style="max-width: 299px">
              {{ party?.name }}
            </h4>
            <h5 class="text-truncate mb-0 black--text">
              {{ ticket?.TicketBlock?.TicketGroup?.name }}
            </h5>
            <b class="text-truncate mb-0 text-12">
              {{ ticket?.TicketBlock?.name }}
            </b>
            <b v-if="ticket?.Table" class="text-truncate mb-0 mt-1">
              <v-icon left small>mdi-table-chair</v-icon>
              {{ ticket?.Table?.Group?.name || "Camarote" }}
              •
              {{ ticket?.Table?.name || "05" }}
            </b>
            <v-spacer />
            <div>
              <span
                class="text-overline font-weight-bold lh-1"
                style="font-size: 10px !important"
              >
                Participante
              </span>
              <h5
                class="mb-0 black--text lh-6"
                style="
                  max-width: 330px;
                  overflow: hidden !important;
                  text-overflow: ellipsis !important;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                "
              >
                {{ share?.name || user?.name }}
              </h5>
              <span v-if="!share">
                {{ obfuscatedCPF }}
              </span>
              <span v-else> Compartilhado por {{ user?.name }} </span>
              <small v-if="shareCount > 0" class="error--text d-block">
                Ingresso compartilhado
                {{ shareCount }} vez{{ shareCount > 1 ? "es" : "" }} antes
              </small>
            </div>
          </div>
        </v-col>
        <v-col cols="auto">
          <div class="d-flex flex-column align-end h-full text-right gap-1">
            <div
              style="
                width: 120px;
                height: 35px;
                background-image: url('/img/logo/logo-dark.png');
                background-size: contain;
                background-position: right top;
                background-repeat: no-repeat;
              "
            ></div>
            <div v-if="ticket?.Payment?.paymentType === 'COURTESY'">
              <h6 class="mb-0 lh-1">Cortesia</h6>
              <p class="mb-0 lh-1">Venda proibida</p>
            </div>
            <v-spacer />
            <div class="text-10 d-flex flex-column">
              <template v-if="share">
                <span class="lh-1 mt-1">Compartilhamento</span>
                <span
                  class="text-overline font-weight-bold"
                  style="font-size: 9px !important; line-height: 1.2"
                >
                  #{{ share?.id | shortId }}
                </span>
              </template>
              <span class="lh-1 mt-1">Pagamento</span>
              <span
                class="text-overline font-weight-bold"
                style="font-size: 9px !important; line-height: 1.2"
              >
                #{{ ticket?.Payment?.id | shortId }}
              </span>
              <span class="lh-1 mt-1">Ingresso</span>
              <span
                class="text-overline font-weight-bold"
                style="font-size: 9px !important; line-height: 1.2"
              >
                #{{ ticket?.id | shortId }}
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import TicketDots from "../../../components/global/TicketDots.vue";

export default {
  name: "ExportTicketDetails",
  components: {
    QrcodeVue,
    TicketDots,
  },
  data() {
    return {};
  },
  methods: {
    getQrCodeLink() {
      const link = new URL(
        `${window.location.origin}/v/t/${this.ticket?.code}`
      );
      if (this.share)
        link.searchParams.set("s", this.share?.id?.slice(0, 8) || "");
      else link.searchParams.set("f", "F");
      return link.toString();
    },
  },
  computed: {
    obfuscatedCPF() {
      if (!this.user?.document) return "";
      return this.user.document
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.***.***-$4");
    },
    shareCount() {
      return this.ticket?.TicketShare?.length - (this.share ? 1 : 0);
    },
  },

  props: {
    party: {
      type: Object,
    },
    ticket: {
      type: Object,
    },
    images: {
      type: Object,
    },
    user: {
      type: Object,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    bgColor: {
      type: String,
      default: "#e7e7e7",
    },
    share: {
      type: Object,
    },
  },
};
</script>

<style scoped>
p {
  display: block;
}

.secondary-ticket {
  /* adicione uma marca d'agua no centro do ingresso*/
  /* Rotacione 45 graus */
  /* Deve ficar atras do conteudo do ingresso */
  &::before {
    content: "Canhoto";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(10deg);
    font-size: 36px;
    font-weight: bold;
    color: #bbb;
    width: 100%;
    text-align: center;
    z-index: 0;
  }
}
</style>
